import moment from "moment";

// util to format numbers into space separated thousands
export const formatPrice = (num = 0, toFixed = 2) => {
  // round to two decimals and split into integer and decimal parts
  const rounded = Number(num).toFixed(toFixed);
  const parts = rounded.split('.');
  // apply thousands separator on the integer part only
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join('.');
}

export const formatText = (text = "") => {
  // Split the text by the bold text
  return text.split(/(\*\*\*.*?\*\*\*)/g).map((part, index) => {
    if (part.startsWith("***") && part.endsWith("***")) {
      return <b key={index}>{part.slice(3, -3)}</b>;
    }
    return part;
  });
}

// util to capitalize first letter of a string
// e.g. "hello world" => "Hello world"
export const capitalizeString = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatDate = (date = null, format = "DD MMM YYYY") => {
  if (!date) return "N/A";
  
  return moment(new Date(date)).format(format);
};